import { render, staticRenderFns } from "./crm-customers.vue?vue&type=template&id=7acce42b&scoped=true&"
import script from "./crm-customers.vue?vue&type=script&lang=js&"
export * from "./crm-customers.vue?vue&type=script&lang=js&"
import style0 from "./crm-customers.vue?vue&type=style&index=0&id=7acce42b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acce42b",
  null
  
)

export default component.exports